<template>
<div class="container">
	<div class="row">
		<div class="col-12">
			<h1 class="my-4">Privacy Policy Notice</h1>
			<h2 class="text-success mb-4">Introduction</h2>
			<p class="lead">
				This privacy policy notice is served by Alcea Ltd, 20-22 
				Wenlock Road, London, England, N1 7GU, under the website: 
				www.appsa.co.uk . The purpose of this policy is to explain 
				to you how we control, process, handle and protect your 
				personal information through the business and while you browse 
				or use this website. If you do not agree to the following policy 
				you may wish to cease viewing / using this website, and or 
				refrain from submitting your personal data to us.	
			</p>
			<h2 class="text-success my-4">Policy key definitions</h2>
			<ul>
				<li>"I", "our", "us", or "we" refer to the business, Appsa, Alcea Ltd.</li>
				<li>"you", "the user" refer to the person(s) using this website.</li>
				<li>GDPR means General Data Protection Act.</li>
				<li>PECR means Privacy & Electronic Communications Regulation.</li>
				<li>ICO means Information Commissioner's Office.</li>
				<li>Cookies mean small files stored on a users computer or device.</li>
			</ul>
			
			<h2 class="text-success my-4">Key principles of GDPR</h2>
			<p>
				Our privacy policy embodies the following key principles:
			</p>
				<ol>
					<li>Lawfulness, fairness and transparency</li>
					<li>Purpose limitation</li>
					<li>Data minimisation</li>
					<li>Accuracy</li>
					<li>Storage limitation</li>
					<li>Integrity and confidence</li>
					<li>Accountability</li>
				</ol>

			<h2 class="text-success my-4">What information do we collect?</h2>
			<p>
				We collect personal information that you submit to us using our website. For example:
			</p>
			<ul>
				<li>Name</li>
				<li>Email address</li>
				<li>Phone number</li>
				<li>Address</li>
			</ul>
			<p>
				We also collect information through your use of the site services. For example:
			</p>
			<ul>
				<li>IP address</li>
				<li>Browser type</li>
				<li>Operating system</li>
				<li>Location</li>
				<li>Access time</li>
				<li>Device type</li>
			</ul>

			<h2 class="text-success my-4">How do we use personal information?</h2>
				<ol>
					<li>Providing services</li>
					<li>Communicate</li>
					<li>Improve services</li>
					<li>Legal compliance and record keeping</li>
					<li>Recruitment</li>
					<li>Other</li>
				</ol>
					<h4 class="my-3">Providing services</h4>
					<p>
						We use this information to communicate with you and to carry out 
						actions you request on the Site, such as requests for support, 
						orders placed and to track the transactions that are performed.
					</p>
					<p>
						We will continue to process your information under this basis until you withdraw consent or it is determined your consent no longer exists
					</p>
					<p>
						We do not share your information with third parties.
					</p>
					<p>
						It is in our legitimate interest to use personal information in such a way to ensure that we can make the best recruitment decisions.
					<p>
					<h4 class="my-3">Communicate</h4>
					<p>
							We use your personal information to be able to communicate with you and provide nescessary feedback.
					</p>
					<p>
						We will continue to process your information under this basis until you withdraw consent or it is determined your consent no longer exists
					</p>
					<p>
						We do not share your information with third parties.
					</p>
					<p>
						It is in our legitimate interest to use personal information in such a way to ensure that we can make the best recruitment decisions.
					<p>
					<h4 class="my-3">Improve services</h4>
					<p>
							We use your personal information to analyse how our services
							are used and take decissions how they could be improved to 
							serve our customers best.
					</p>
					<p>
						We will continue to process your information under this basis until you withdraw consent or it is determined your consent no longer exists
					</p>
					<p>
						We do not share your information with third parties.
					</p>
					<p>
						It is in our legitimate interest to use personal information in such a way to ensure that we can make the best recruitment decisions.
					<p>
					<h4 class="my-3">Legal compliance and record keeping</h4>
					<p>
							Wenever required we may keep your personal details for legal 
							compliance reasons as well as for our internal record keeping
							when it is needed for ongoing project or ensure correct post 
							delivery support services. 
					</p>
					<p>
						We will continue to process your information under this basis until you withdraw consent or it is determined your consent no longer exists
					</p>
					<p>
						We do not share your information with third parties.
					</p>
					<p>
						It is in our legitimate interest to use personal information in such a way to ensure that we can make the best recruitment decisions.
					<p>
					<h4 class="my-3">Recruitment</h4>
					<p>
							We use your personal information to assess your suitability for any position for which you may apply.
					</p>
					<p>
						We will continue to process your information under this basis until you withdraw consent or it is determined your consent no longer exists
					</p>
					<p>
						We do not share your information with third parties.
					</p>
					<p>
						It is in our legitimate interest to use personal information in such a way to ensure that we can make the best recruitment decisions.
					<p>
					<p class="mt-3">
						If, as determined by us, the lawful basis upon which we process your personal information changes, we will notify you about the change and any new lawful basis to be used if required. We shall stop processing your personal information if the lawful basis used is no longer relevant.
					</p>

			<h2 class="text-success my-4">Your individual rights</h2>
			<p>
				Under the GDPR your rights are as follows. You can read more about <a href="https://ico.org.uk/for-organisations/guide-to-the-general-data-protection-regulation-gdpr/individual-rights/">your rights in details here</a>
			</p>
			<ul>
				<li>the right to be informed;</li>
				<li>the right of access;</li>
				<li>the right to rectification;</li>
				<li>the right to erasure;</li>
				<li>the right to restrict processing;</li>
				<li>the right to data portability;</li>
				<li>the right to object; and</li>
				<li>the right not to be subject to automated decision-making including profiling</li>
			</ul>
			<p>
				You also have the right to complain to the ICO [www.ico.org.uk] if you feel there is a problem with the way we are handling your data.
			</p>
			<p>
				We handle subject access requests in accordance with the GDPR.
			</p>

			<h2 class="text-success my-4">Internet cookies</h2>
			<p>
				We use cookies on this website to provide you with a better user experience. We do this by placing a small text file on your device / computer hard drive to track how you use the website, to record or log whether you have seen particular messages that we display, to keep you logged into the website where applicable, to display relevant adverts or content, referred you to a third party website.
			</p>
			<p>
				Some cookies are required to enjoy and use the full functionality of this website.
			</p>
			<p>
				We use a cookie control system which allows you to accept the use of cookies, and control which cookies are saved to your device / computer. Some cookies will be saved for specific time periods, where others may last indefinitely. Your web browser should provide you with the controls to manage and delete cookies from your device, please see your web browser options.
			</p>
			<p>
				Cookies that we use are;
			</p>
			<ul>
				<li>appsa</li>
			</ul>

			<h2 class="text-success my-4">Data security and protection</h2>
			<p>
				We ensure the security of any personal information we hold by using secure data storage technologies and precise procedures in how we store, access and manage that information. Our methods meet the GDPR compliance requirement.
			</p>

			<h2 class="text-success my-4">Fair & Transparent Privacy Explained</h2>
			<p>
				We have provided some further explanations about user privacy and the way we use this website to help promote a transparent and honest user privacy methodology.
			</p>
			
			<h2 class="text-success my-4">How to contact us?</h2>
			
			<p>
				If you have any questions about this privacy notice or want to exercise your rights, please contact us by:
			</p>
			<ul>
				<li>sending an e-mail to: info@appsa.co.uk</li>
				<li>or writing to us at: 94B Regent Street, Cambridge, CB2 1DP, United Kingdom</li>
			</ul>



		</div>
	</div>
</div>
</template>

<script>
export default {
	data() {
		return {
			metadata: {
				section: "notice",
				title: "Privacy Policy"
			}
		}
	},
	methods: {
		loadToParent: function() {
			this.$emit("data-to-parent", this.metadata);
		}
	},
	mounted: function() {
		this.loadToParent();	
	},
}
</script>
